module.exports = __webpack_public_path__ + "static/img/hatopress-workshops-archive-1.44e436a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workshops/hatopress-workshops-archive-1.jpg
// module id = 180
// module chunks = 1